import { useSelector, shallowEqual } from 'react-redux';

import {
  useFeatureToggleData,
  FEATURE_LINKOUT,
} from 'src/app/shared/featureToggle';
import type { AppState } from 'src/types/appState';
import { ApplyViaOptions } from 'src/types/linkOut';

export const useIsApplyViaSeek = () => {
  const { linkOutApplyVia } = useSelector(
    (state: AppState) => ({
      linkOutApplyVia: state.formData.linkOutApplyVia,
    }),
    shallowEqual,
  );
  const hasLinkOutEnabled = useFeatureToggleData(FEATURE_LINKOUT);

  return (
    !hasLinkOutEnabled ||
    (hasLinkOutEnabled && linkOutApplyVia === ApplyViaOptions.SEEK_WEBSITE)
  );
};
